module.exports = __webpack_public_path__ + "img/33.12988934.svg";